module.exports = __webpack_public_path__ + "static/media/underweight.fc65fa6e.png";